<script lang="ts" setup>
import { getNotFoundRobotsContent } from '~/utils/httpSeo';

const error = useError();
const is404 = computed(() => error.value?.statusCode === 404);

if (is404.value) {
  if (import.meta.server) {
    const event = useRequestEvent();
    const robotsHeader = useResponseHeader('X-Robots-Tag');
    robotsHeader.value = getNotFoundRobotsContent();

    if (event) {
      setResponseStatus(event, 404, 'Page Not Found');
    }
  }

  useHead({
    meta: [{ name: 'robots', content: getNotFoundRobotsContent() }],
  });
}
</script>

<template>
  <div
    v-if="is404"
    class="page-not-found"
  >
    <div class="flex flex-col items-center py-20 px-4 text-center">
      <span class="text-6xl font-bold"> 404 </span>

      <h1 class="text-2xl sm:text-5xl mt-5 sm:mt-7">Страница не найдена</h1>

      <div class="flex gap-7 sm:gap-10 flex-wrap justify-center mt-10">
        <TheBtn
          color="outline"
          to="/"
        >
          На главную
        </TheBtn>

        <TheBtn to="/catalog">В каталог</TheBtn>
      </div>
    </div>
  </div>

  <div v-else>
    <div class="flex items-center justify-center h-screen">
      <div class="flex flex-col gap-14 py-24 px-4 text-center">
        <h1 class="text-8xl sm:text-9xl font-black">{{ error?.statusCode }}</h1>

        <h2 class="text-2xl sm:text-5xl">Произошла ошибка</h2>

        <p>Попробуйте обновить страницу или вернуться немного позже.</p>

        <p>
          Если ошибка повторяется –
          <AppLink
            class="text-label-violet"
            to="/info/kontakty"
          >
            сообщите нам
          </AppLink>
          .
        </p>

        <div class="flex gap-5 sm:gap-10 flex-column sm:flex-row justify-center">
          <TheBtn
            color="outline"
            to="/"
          >
            На главную
          </TheBtn>

          <TheBtn
            color="outline"
            to="/catalog"
          >
            В каталог
          </TheBtn>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-not-found {
  @include inner-content;
}
</style>
